import { Observable, of } from 'rxjs';
import { catchError, filter, first, map, mergeMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { AppState } from '../core.state';
import { ForgotPassword, GetLoggedUser } from './auth.actions';
import { selectLoggedUser } from './auth.selectors';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class LoggedUserGuard implements CanActivate {
    constructor(private store: Store<AppState>, private authService: AuthService, private router: Router) { }

    canActivate(): Observable<boolean> {

        return this.authService.signedIn
            .pipe(
                mergeMap(isAuthenticated => {
                    if (isAuthenticated) {
                        return this.checkStore();
                    } else if (location.href.indexOf('AADB2C90118') >= 0) {
                        this.store.dispatch(new ForgotPassword());
                    } else {
                        return this.router.navigateByUrl('/login');
                    }
                })
            ).pipe(
                catchError(() => of(false))
            );
    }

    checkStore(): Observable<boolean> {
        return this.store.select(selectLoggedUser).pipe(
            tap(loggedUser => {
                if (!loggedUser) {
                    this.store.dispatch(new GetLoggedUser());
                }
            }),
            filter(loaded => !!(loaded)),
            map(u => !!u),
            first()
        );
    }
}
